// removed by extract-text-webpack-plugin
module.exports = {"tagCloud":"antd-pro-charts-tag-cloud-tagCloud"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Charts/TagCloud/index.less
// module id = 1087
// module chunks = 0